import React, { FC } from 'react';
import classNames from 'classnames';
import { LoadingComponent } from '@clearcover/atlas';
import { formatDateShort, formatMoney } from 'Shared/utils';
import styles from './styles.module.css';

type AutoPayScheduleTablePropsType = {
  items: Array<{ date: string; amount: string | number }>;
  loading: boolean;
};

export const AutoPayScheduleTable: FC<AutoPayScheduleTablePropsType> = ({
  items,
  loading,
}) => {
  return (
    <section className={styles.table}>
      <div className={classNames(styles.tableHeader, styles.tableRow)}>
        <div>Payment Date</div>
        <div>Premium Amount</div>
      </div>
      <>
        {loading ? (
          <LoadingComponent className={styles.loadingComponent} />
        ) : (
          <>
            {items.map(({ date, amount }, index) => (
              <div
                key={date}
                className={styles.tableRow}
                data-testid={`payment-schedule-${index}`}
              >
                <div
                  className={styles.date}
                  data-testid={`payment-schedule-date-${index}`}
                >
                  {formatDateShort(date)}
                </div>
                <div
                  className={styles.value}
                  data-testid={`payment-schedule-amount-${index}`}
                >
                  {formatMoney(amount)}
                </div>
              </div>
            ))}
          </>
        )}
      </>
    </section>
  );
};
